module.exports = __webpack_public_path__ + "img/product6.f07c3072.png";